import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    period: checkRequiredText(settings),
});

export const PeriodSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Row className="mb-3">
                <Form.Group as={Col} controlId="formPeriod">
                    <Form.Label>Für welchen Zeitraum bewirbst Du Dich?*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Zeitraum eingeben"
                        type="text"
                        name="period"
                        value={values.period}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.period && !errors.period}
                        isInvalid={touched.period && errors.period}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.period}
                    </Form.Control.Feedback>
                </Form.Group>
          </Row>
        </>
    );
};